import { Component, EventEmitter, OnInit, Output,Inject, PLATFORM_ID } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService, SeoService, PaginationService } from '../../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';

@Component({
  selector: 'app-podcast-detail',
  templateUrl: './podcast-detail.component.html',
  styleUrls: ['./podcast-detail.component.css']
})
export class PodcastDetailComponent implements OnInit {

  podcastId: any;
  userSubscription: Subscription;
  hostName = environment.BaseURL +"/podcasts-web/podcast/";
  podcastDetailRes: any = {};
  @Output() onAudioPlay = new EventEmitter<any>();
  episodeArray: any = [];
  pager: any = {};

  // paged items
  pagedItems: any[];
  //---------------------
  total_record: number = 0;
  userRole:any;
  nextPage:any;
  prevPage:any;
  page: any = 1;
  alias:any='';
  total: any = 0;
  totalPages: any = 0;
  objectKeys = Object.keys;
  episodeList:any = [];


  constructor(private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private helperSvc: HelperService,
    private title: Title,
    private seoService: SeoService,
    private pagerService: PaginationService,
    private router: Router, private spinner: NgxSpinnerService,
    private _route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platform: Object) { }

  ngOnInit(): void {
    this.userSubscription = this._route.params.subscribe(
      (params: Params) => {
        const desc = this._route.snapshot.paramMap.get('podcastname')!;
        let alias = desc;
        this.alias = alias;
        this.getPodcastByAlias(alias);
      })
  }


  getPodcastByAlias(alias) {
    this.spinner.show();
    this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTBYALIAS, '?alias=' + alias).subscribe(
      res => {
        if (res) {
          let data = res;
          this.podcastDetailRes = data;
          let podcast = this.podcastDetailRes
          this.episodeList = data.episodes;
          this.totalPages = data.total_no_of_page;
          this.total = 10 * (this.totalPages);

          this.pager = this.pagerService.getPager(this.total, 1, 10);

          let descWithoutTags = podcast.podcast_description ? podcast.podcast_description .replace(/<(.|\n)*?>/g, '') : '';
            this.seoService.updateCanonicalUrl(this.hostName + podcast.alias);
            this.seoService.updateImageSorce(podcast.image);
            this.title.setTitle(podcast.podcast_name + ' | Hayti - News, Videos and Podcasts from Black Publishers');
            this.seoService.updateMetaTags([
              { name: 'keywords', content: '' },
              { name: 'description', content: descWithoutTags },
              { property: 'og:title', content: podcast.podcast_name },
              { property: 'og:url', content: this.hostName + podcast.alias },
              { property: 'og:description', content: descWithoutTags },
              { property: 'og:image', content: podcast.image },
              { property: 'og:image:url', content: podcast.image },
              { property: "og:site_name", content: "Hayti - News, Videos and Podcasts from Black Publishers" },
              { property: "og:type", content: "podcast" },

              { name: "twitter:card", content: "summary_large_image" },
              { name: 'twitter:site', content: '@haytiapp' },
              { name: 'twitter:description', content: descWithoutTags },
              { name: 'twitter:title', content: podcast.podcast_name },
              { name: 'twitter:creator', content: '@haytiapp' },
              { name: 'twitter:url', content: this.hostName + podcast.alias },
              { name: 'twitter:image', content: podcast.image },
              { name: 'twitter:image:alt', content: podcast.image }
            ]);


          // if (data.podcast_name == null) {
          //   this.router.navigate(['/404'], { skipLocationChange: true });
          // }
          this.spinner.hide();
        }
      }, err => {
        this.spinner.hide();
      }
    );
  }

  playAudio(episode) {
    episode.podcast_name = this.podcastDetailRes.podcast_name;
    this.helperSvc.changeAudioData(episode);  //invoke new Dat
    this.helperSvc.setAudioPlayerList(episode);
  }

  secondsToDhmsOld(seconds) {
    seconds = Number(seconds);
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var hDisplay = h > 0 ? (h < 10 ? "0" + h : h) : "00";
    var mDisplay = m > 0 ? (m < 10 ? "0" + m : m) : "00";
    var sDisplay = s > 0 ? (s < 10 ? "0" + s : s) : "00";
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  secondsToDhms(seconds) {
    const portions: string[] = [];
  
    const msInHour = 1000 * 60 * 60;
    const hours = Math.floor(seconds % (3600 * 24) / 3600);
    if (hours > 0) {
      portions.push(hours + ' h');
      // duration = duration - (hours * msInHour);
    }
  
    const msInMinute = 1000 * 60;
    const minutes =  Math.floor(seconds % 3600 / 60);
    if (minutes > 0) {
      portions.push(minutes + ' min');
      // duration = duration - (minutes * msInMinute);
    }
  
    const sec =  Math.floor(seconds % 60);
    if (sec > 0) {
      portions.push(sec + ' sec');
    }
  
    return portions.join(' ');
  }

  clickPageSearch(page: number, type) {
    if(type == 'prev'){
      this.nextPage = '';
    }else{
      this.prevPage = '';
    }
    this.handlePageChange(page);
   
    // this.router.navigate(["/news"], { queryParams: { page: page } });
  }

  handlePageChange(event: any) {
    this.page = event;    
    // this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTBYALIAS, '?alias=' + this.alias +'&next_record_ts=' + this.nextPage + '&prev_record_ts=' + this.prevPage).subscribe(
      this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTBYALIAS, '?alias=' + this.alias +'&page=' + this.page ).subscribe(
      res => {
        if (res) {
          let data = res;
          let episodeList = data.episodes;

          this.episodeList = this.episodeList.concat(episodeList);
          // this.nextPage = data.next_record_ts;
          // this.prevPage = data.prev_record_ts;
          this.totalPages = data.total_no_of_page;
          this.total = 10 * (this.totalPages);
          // this.pager = this.pagerService.getPager(this.total, this.page, 10);
          // this.spinner.hide();
        }
      }, err => {
        // this.spinner.hide();
      }
    );
    // if (isPlatformBrowser(this.platform)) {
    //   window.scrollTo(0, 0);
    // }
  }

  viewMore() {
    let page = this.page + 1;
    this.page = page;
    if(this.totalPages >= page){
      this.handlePageChange(page);
    }
  }
 
}
